module.exports = __webpack_public_path__ + "static/media/green.b080eb65.jpg";